import styled from 'styled-components'

export const MCCILogo = styled.img`
  width: 40px;
  position: absolute;
  left: 20px;
  bottom: 20px;
  z-index: 99;
  display: block;
  pointer-events: none;
`

const Logo = styled.img`
  width: 120px;
  position: absolute;
  left: 50%;
  top: 10px;
  z-index: 99;
  display: block;
  transform: translateX(-50%);
  pointer-events: none;
`

export default Logo;